<template>
  <div class="further-more-divider" />
  <SectionTemplate :title="$t('cai-ni-xiang-le-jie')">
    <div class="card-list">
      <MoreCard v-for="(item, idx) in cards" :key="idx" v-bind="item" />
    </div>
    <button @click="handleAllPosts" class="view-all-btn">
      {{ $t('cha-kan-quan-bu-wen-zhang') }}
      <ArrowRight class="text-[22px]" />
    </button>
  </SectionTemplate>
</template>

<script setup lang="ts">
import SectionTemplate from '@/design/widgets/landing-section/cn-template.vue';
import ArrowRight from '~/assets/svg/icon-arrow-right.svg?component';
import { type IRecommendCard } from '../../types';
import MoreCard from '../article-card.vue';

const props = defineProps<{
  cards: IRecommendCard[];
}>();

const handleAllPosts = () => {
  navigateTo('/academy', {
    external: true,
    open: {
      target: '_blank',
    },
  });
};
</script>

<style lang="scss" scoped>
.further-more-divider {
  width: 100vw;
  height: 0;
  border-top: 1px solid var(--x-back-4);
}
.card-list {
  @apply inline-flex items-center gap-6 mb-20 h-[520px];
}
.view-all-btn {
  @apply flex-center gap-3 py-[9px] px-[31px];
  color: var(--x-text-3);
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  line-height: normal;
  border-radius: 8px;
  border: 1px solid var(--x-back-5);
  background: var(--x-back-1);
  /* 投影 -小 */
  box-shadow: 0 2px 2px 0 rgba(18, 25, 38, 0.06);
  transition: all 0.3s ease-in;
  &:hover {
    background: var(--x-back-3);
  }
}
</style>
